import { getClientBranding } from '@brands/services/identity/getClientBranding';
import { setClientBranding } from '@brands/store/slices/clientBrandingSlice';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { useEffect } from 'react';

import { useAppDispatch } from './useReduxHook';

/**
 * Applies a client's branding for an anonymous visitor landing on
 * /{clientCode} or /{clientCode}/sign-up, before any authentication exists.
 * Resets branding to null when clientCode is absent so a stale value from an
 * earlier client-coded visit (clientBranding is Redux-Persisted) doesn't leak
 * into a plain "/" or "/sign-up" visit later in the same browser.
 */
export const useClientBrandingFromUrl = (clientCode: string | undefined): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!clientCode) {
      dispatch(setClientBranding({ clientBranding: null }));
      return;
    }

    (async (): Promise<void> => {
      try {
        const clientBranding = await getClientBranding(clientCode);
        dispatch(setClientBranding({ clientBranding }));
      } catch (error: unknown) {
        displayErrorDetails(error);
      }
    })();
  }, [clientCode, dispatch]);
};
